import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listBlogPosts } from "@/lib/api";
import { ArrowUpRight } from "lucide-react";
import { TID } from "@/constants/testIds";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    listBlogPosts().then((p) => { setPosts(p); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  return (
    <div>
      <section className="section-pad pb-8 bg-offwhite pt-32">
        <div className="container-editorial grid md:grid-cols-12 gap-10">
          <aside className="md:col-span-4">
            <div className="eyebrow text-teal mb-4"><span className="editorial-rule" /> The Journal</div>
            <h1 className="font-display text-forest text-5xl md:text-6xl leading-[0.98]">
              Long-form<br />on land.
            </h1>
            <p className="mt-6 text-forest/70 leading-relaxed max-w-md">
              The essays behind Chapter III — connectivity, paperwork, the
              land-SIP idea, and why golden-hour visits matter. Slow reads for
              people considering slow decisions.
            </p>
          </aside>
          <div data-testid={TID.blogList} className="md:col-span-8 divide-y divide-forest/15 border-y border-forest/15">
            {loading && <div className="py-10 text-forest/50 text-sm">Loading…</div>}
            {!loading && posts.length === 0 && (
              <div className="py-10 text-forest/50 text-sm">No posts yet.</div>
            )}
            {posts.map((p) => (
              <Link
                data-testid={TID.blogCard}
                key={p.slug}
                to={`/blog/${p.slug}`}
                className="group grid md:grid-cols-12 gap-6 py-8 items-start"
              >
                <div className="md:col-span-4 relative overflow-hidden rounded-md aspect-[4/3]">
                  <img src={p.cover_image} alt={p.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" />
                </div>
                <div className="md:col-span-8 space-y-3">
                  <div className="eyebrow text-teal">{p.category} · {p.read_minutes} min read</div>
                  <h2 className="font-display text-forest text-2xl md:text-3xl leading-tight group-hover:underline underline-offset-4 decoration-lime decoration-2">
                    {p.title}
                  </h2>
                  <p className="text-forest/75 text-[15px] leading-relaxed max-w-2xl">
                    {p.excerpt}
                  </p>
                  <div className="inline-flex items-center gap-2 text-forest text-xs tracking-widest uppercase pt-2">
                    Read the essay <ArrowUpRight size={14} />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
